import { render, staticRenderFns } from "./CustomImportButton.vue?vue&type=template&id=1213743e&"
import script from "./CustomImportButton.vue?vue&type=script&lang=ts&"
export * from "./CustomImportButton.vue?vue&type=script&lang=ts&"
import style0 from "./CustomImportButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports